import React from "react";
import { Backdrop, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";
import clsx from "clsx";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

// Styled components for MUI v5
const Container = styled(Paper)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  maxWidth: "60%",
  minHeight: "150px",
  minWidth: "300px",
  padding: "16px",
}));

const HeightBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 100, // Similar to zIndex 1400 from MUI v4
}));

const Progress = styled("div")({
  height: "15px",
  width: "80%",
});

const RelativeBackdrop = styled(Backdrop)({
  position: "absolute",
});

const Text = styled(Typography)({
  margin: "0 0 10px 0",
});

export const Loading = ({ custom, fullScreen, message, open }) => {
  return (
    <HeightBackdrop className={clsx({ relative: !fullScreen })} open={open}>
      {custom ? (
        custom
      ) : (
        <Container elevation={0}>
          <LoadingSpinner />
          {message && <Text variant="h6">{message}</Text>}
          {/* Uncomment if LinearProgress is needed */}
          {/* <LinearProgress className={Progress} variant="query" /> */}
        </Container>
      )}
    </HeightBackdrop>
  );
};
